import request from '@/utils/request'
let preBase = 'mixApi'

// 云南邮储白名单H5项目-登录
export const login = (data) => {
  return request({
    url: `${preBase}/yunnanPsbc/login`,
    method: 'post',
    data,
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 云南邮储白名单H5项目-获取客户信息
export const getCustomerInfo = (data) => {
  return request({
    url: `${preBase}/yunnanPsbc/getUserInfo`,
    method: 'post',
    data,
    token: sessionStorage.getItem('yunnanPsbcToken'),
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
// 云南邮储白名单H5项目-获取已领取数量
export const getReceiveCount = (data) => {
  return request({
    url: `${preBase}/yunnanPsbc/getReceiveCount`,
    method: 'post',
    data,
    token: sessionStorage.getItem('yunnanPsbcToken'),
    hideLoading: true,

  })
}
// 云南邮储白名单H5项目-查询支付宝账号
export const selectAccount = (data) => {
  return request({
    url: `${preBase}/yunnanPsbc/selectAccount`,
    method: 'post',
    data,
    token: sessionStorage.getItem('yunnanPsbcToken'),
    hideLoading: true,
  })
}
// 云南邮储白名单H5项目-领券
export const receive = (data) => {
  return request({
    url: `${preBase}/yunnanPsbc/receive`,
    method: 'post',
    data,
    token: sessionStorage.getItem('yunnanPsbcToken'),
    hideLoading: true,
    hideErrMsgToast: true,
  })
}
